import { useState, useEffect, useContext } from "react";

import { Typography, Box, Dialog, DialogContent, Button } from "@mui/material";
import * as React from "react";
import { useParams } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Container from "@mui/material/Container";
import { ValidationGroup, Validate, useValidation } from "mui-validate";

import { Trans } from "./Translations";
import { MapItem, MapCategory } from "./CommonDataTypes";
import { client } from "./RpcClient";
import { config } from "./Config";
import { CurrentElements } from "./Sofas/DataTypes";

export default function ContactForm(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  curElements: CurrentElements;
}) {
  const { _ } = useContext(Trans);
  const [validation, setValidation] = useState<"silent" | "noisy">("silent");
  const [emailUseChecked, setEmailUseChecked] = useState(true);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const ggM = (key: string) => {
      const val = data.get(key);
      if (typeof val === "string") {
        return val.length > 0 ? val : undefined;
      } else {
        return undefined;
      }
    };
    const gg = (key: string) => {
      const val = ggM(key);
      if (val === undefined) {
        throw Error(`undefined value for key: ${key}`);
      }
      return val;
    };
    try {
      const user = {
        name: gg("name"),
        lastname: gg("lastname"),
        email: gg("email"),
        company: ggM("company"),
        phone: ggM("phone"),
        zip_code: ggM("zip_code"),
        follow_up: emailUseChecked,
        profile: gg("profile"),
        comments: ggM("comments"),
        elements: window.location.href,
      };
      try {
        const response = await fetch(`${config.apiUrl}/contact-form-submit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(user),
        });
        props.setOpen(false);
      } catch (err) {
        console.error(err);
      }
    } catch (_) {
      console.log("SETTING VALIDATION to noisy");
      setValidation("noisy");
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailUseChecked(event.target.checked);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={props.open}
      onClose={() => props.setOpen(false)}
    >
      <DialogContent>
        <Button
          sx={{ float: "right" }}
          variant="outlined"
          onClick={() => {
            props.setOpen(false);
          }}
        >
          {_("Close")}
        </Button>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
            postion: "absolute",
            top: 0,
            left: 0,
            overflowX: "none",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              overflow: "auto",
            }}
          >
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Box
                sx={{
                  marginTop: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography component="h1" variant="h5">
                  Enter Enquiry Data
                </Typography>
                <ValidationGroup>
                  <Box
                    component="form"
                    // noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 3 }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Validate name="name" required>
                          <TextField
                            autoComplete="given-name"
                            name="name"
                            required
                            fullWidth
                            id="name"
                            label="First Name"
                            autoFocus
                          />
                        </Validate>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Validate name="lastname" required>
                          <TextField
                            required
                            fullWidth
                            id="lastname"
                            label="Last Name"
                            name="lastname"
                            autoComplete="family-name"
                          />
                        </Validate>
                      </Grid>
                      <Grid item xs={12}>
                        <Validate
                          name="email"
                          required
                          regex={
                            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                          }
                        >
                          <TextField
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                          />
                        </Validate>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="company"
                          label="Company"
                          id="company"
                          autoComplete="company"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="phone"
                          label="Phone"
                          id="phone"
                          autoComplete="phone"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name="zip_code"
                          label="Project ZIP code"
                          id="zip_code"
                          autoComplete="zip"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={emailUseChecked}
                              onChange={handleEmailChange}
                              value="allowExtraEmails"
                              color="primary"
                            />
                          }
                          label="I would like a representative to follow up with me."
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Validate name="profile" required>
                          <TextField
                            required
                            fullWidth
                            name="profile"
                            label="Profile (distributor/designer/owner/bartender)"
                            id="profile"
                          />
                        </Validate>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          multiline
                          minRows={3}
                          fullWidth
                          name="comments"
                          label="Comments"
                          id="comments"
                        />
                      </Grid>
                    </Grid>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                    >
                      SUBMIT
                    </Button>
                  </Box>
                </ValidationGroup>
              </Box>
            </Container>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
